import React, { Fragment, useState } from "react";
import { isMobile } from "react-device-detect";
import { Dialog } from "@material-ui/core";
import SvTaskForm from "./SvTaskForm";
import { DownloadSvSampleFile } from "../apiServices";
import { convertFilterObject, removeEmptyKey, permissionCheckFnforCamo, getLocalStorageInfo } from "../../../../utils";
import CamoCTA from "../../../../shared_elements/components/cta/CamoCTA";

const SvSearchBar = ({ applyingFilter, tabIndex, pageLoader, props, searchData, fileUploadData, importFile, exportReportFn, currentRecordPerPage, uuid, getResponseBack, techSpecDetail, basicDetails }) => {
	const [open, setOpen] = useState(false);
	const [formTitle, setFormTitle] = useState("");
	const [actionType, setActionType] = useState("");

	const boeingInstance = getLocalStorageInfo()?.defaultLessor?.id === 475;

	const addNewTask = () => {
		setOpen(true);
		setFormTitle("Shop Visit");
		setActionType("add");
	};

	const importFileFunc = (e) => {
		const formData = new FormData();
		formData.append("file", e.target.files[0]);
		importFile(formData, props, true);
		e.target.value = null;
	};

	const filterParams = convertFilterObject(removeEmptyKey(applyingFilter));

	return (
		<Fragment>
			<div id="AmpSearchBar">
				<CamoCTA
					searchPlaceholder="Search By ,Removal Reason, Shop Visit Location, Shop Visit Workscope"
					onSearch={(value) => searchData({ target: { value } })}
					permissionCheck={!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "C" }) || window?.location?.search.includes('archived-assets')}
					addLabel="ADD SHOP VISIT"
					onAddFn={addNewTask}
					onImportFn={!boeingInstance ? importFileFunc : undefined}
					exportMenu={{
						exportReportFn: exportReportFn,
						files: [
							{ title: 'PDF', extension: 'pdf', key: '' },
							{ title: 'EXCEL', extension: 'xlsx', key: '' },
						],
					}}
					downloadSampleMenu={!boeingInstance ? {
						exportReportFn: (file) => DownloadSvSampleFile(
							{ download: file.extension, ...filterParams, asset_type: tabIndex },
							pageLoader, props, basicDetails
						),
						files: [
							{ title: 'DOWNLOAD SAMPLE', extension: 'xlsx', key: '' },
						],
					} : undefined}
				/>
				<Dialog open={open} style={{ height: isMobile && "650px" }}>
					<SvTaskForm
						formTitle={formTitle}
						closeAddForm={() => setOpen(false)}
						addForm={() => setOpen(true)}
						props={props}
						actionType={actionType}
						fileUploadData={fileUploadData}
						currentRecordPerPage={currentRecordPerPage}
						uuid={uuid}
						getResponseBack={() => getResponseBack()}
						basicDetail={basicDetails}
						techSpecDetail={techSpecDetail}
					/>
				</Dialog>
			</div>
		</Fragment>
	);
};

export default SvSearchBar;
